import { Route, Redirect } from 'react-router-dom';
import { getToken } from 'utils';

interface Props{
    exact: boolean
    path: string
    children: React.ReactNode
}

export default function PrivateRoute({ exact, path, children }: Props): JSX.Element {
    if (!getToken()) {
        return <Redirect to='/login' />;
    }

    return <Route exact={exact} path={path}>{children}</Route>;
}
